import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "./components/Home";
import About from "./components/About";
import Rooms from "./components/Rooms";
import Footer from "./components/Footer";
import ScrollToTop from "./components/ScrollToTop";
import RegisterForm from "./components/RegisterForm";

const App = () => {
  return (
    <BrowserRouter >
    <ScrollToTop/>

      <Routes>
        <Route path='/'
          element={<Home />}
        />
        <Route path='about'
          element={<About />}
        />
        <Route path='rooms'
          element={<Rooms />}
        />
        <Route path='contact'
          element={<RegisterForm/>}
        />
      </Routes>
     <Footer/>

    </BrowserRouter>
  );
};

export default App;